export default __webpack_public_path__ + "static/media/avatar4.34148261.svg";